import Vue from "vue";
import VueRouter from "vue-router";
import { i18n } from "../plugins/i18n";
import store from "../store";
import analytics from "../utils/analytics";
import auth from "../utils/auth";
import Root from "./Root.vue";
import analyticsPlugin from "../utils/eventAnalytics/plugin";
// import notifications from "../utils/notifications";

Vue.use(VueRouter);

const Home = () => import("../components/Home/Home.vue");
const Search = () => import("../components/Search/Index.vue");
const DownloadFixtures = () =>
	import("../components/DownloadFixtures/Index.vue");
const Shikisha = () => import("../components/Shikisha/Index.vue");
const MainBetslip = () => import("../components/Betslip/MainBetslip.vue");
const PrebetMarkets = () => import("../components/Prebets/Markets.vue");
const Countries = () => import("../components/Prebets/Countries.vue");
const TopLeagues = () => import("../components/Prebets/TopLeagues.vue");
const ShikishaMarkets = () => import("../components/Shikisha/Markets.vue");
const Login = () => import("../components/Session/Login.vue");
const Register = () => import("../components/Session/Register.vue");
const KycInitial = () => import("../components/Session/KycInitial.vue");
const KycAllRequirements = () =>
	import("../components/Session/KycAllRequirements.vue");
const Profile = () => import("../components/Session/Account/Index.vue");
const DepositPage = () =>
	import("../components/Session/Account/DepositPage.vue");
const WithdrawPage = () =>
	import("../components/Session/Account/WithdrawPage.vue");
const Transactions = () =>
	import("../components/Session/Account/Transactions.vue");
const MyBets = () => import("../components/Session/MyBets.vue");
const MyBetsBetDetail = () => import("../components/Session/BetDetail.vue");
const WeeklyJackpot = () => import("../components/Jackpots/Index.vue");
const GrandJackpotEvent = () => import("../components/Jackpots/Event.vue");
const WeeklyJackpotResults = () => import("../components/Jackpots/Results.vue");
const MidweekJackpot = () => import("../components/Jackpots/MidweekEvent.vue");
const JackpotResult = () => import("../components/Jackpots/Result.vue");
const Live = () => import("../components/Live/Matches.vue");
const BetikaSnap = () => import("../components/Shared/BetikaSnap.vue");
const LiveMarkets = () => import("../components/Live/Markets.vue");
const ResetPassword = () => import("../components/Session/ResetPassword.vue");
const LiveScore = () => import("../components/Live/LiveScore.vue");

const BoostedMultibet = () => import("../components/BoostedMultibet/Index.vue");
const BoostedMultibetEvents = () =>
	import("../components/BoostedMultibet/Events.vue");
const BoostedMultibetEvent = () =>
	import("../components/BoostedMultibet/Event.vue");

const Virtuals = () => import("../components/Virtuals/Index.vue");
const VirtualsHub = () => import("../components/VirtualsHub/Index.vue");
const VirtualsGamePage = () => import("../components/VirtualsHub/GamePage.vue");
const Matchdays = () => import("../components/Virtuals/Matchdays.vue");
const Ongoing = () => import("../components/Virtuals/Ongoing.vue");
const Table = () => import("../components/Virtuals/Table.vue");
const Results = () => import("../components/Virtuals/Results.vue");
const VirtualMarkets = () => import("../components/Virtuals/Markets.vue");
const Leagues = () => import("../components/Virtuals/Leagues.vue");
const Casino = () => import("../components/Casino/Games.vue");
const Spribe = () => import("../components/Spribe/Games.vue");
const SpribeGamePage = () => import("../components/Spribe/GamesPage.vue");
const CasinoCategoryDetail = () =>
	import("../components/Casino/CategoryDetail.vue");
const CasinoGamePage = () => import("../components/Casino/GamePage.vue");
const Share = () => import("../components/Share/Index.vue");
const splitPotGamePage = () => import("../components/Stp/GamePage.vue");
const splitPot = () => import("../components/Stp/Games.vue");
const cometCrash = () => import("../components/Stp/CometCrashPage.vue");
const betikaLotto = () => import("../components/Lotto/LottoIframe.vue");
const GoldenRaceGames = () => import("../components/GoldenRaceGames/Index.vue");
const Notifications = () => import("../components/Notifications/Index.vue");
const NotificationsDetails = () =>
	import("../components/Notifications/NotificationDetails.vue");
const TermsAndConditions = () =>
	import("../components/TermsAndConditions/Index.vue");
const TermsAndConditionsSubCategories = () =>
	import("../components/TermsAndConditions/SubCategories.vue");
const TermsAndConditionsMiniCategoriesOrContent = () =>
	import("../components/TermsAndConditions/MiniCategoriesOrContent.vue");
const TermsAndConditionsMiniCategory = () =>
	import("../components/TermsAndConditions/MiniCategory.vue");
const FreeBets = () => import("../components/Offers/FreeBets/Index.vue");
const FreeBetsDetails = () =>
	import("../components/Offers/FreeBets/FreebetDetail.vue");
const PromotionSingle = () => import("../components/Offers/Promos/Single.vue");
const PromotionSingleStatic = () =>
	import("../components/Offers/Promos/Static/Single.vue");
const PromosList = () => import("../components/Offers/Promos/Index.vue");

const TransactionHistory = () =>
	import("../components/Session/Account/Transactions/Index.vue");
const Jisort = () => import("../components/Session/Account/Jisort/Index.vue");
const DeleteAccount = () =>
	import("../components/Session/Account/DeleteAccount.vue");
const TransactionHistorySingle = () =>
	import("../components/Session/Account/Transactions/Single.vue");

const crashGamesGamePage = () =>
	import("../components/CrashGames/GamePage.vue");
const crashGames = () => import("../components/CrashGames/Games.vue");
const viewCrashGame = () => import("../components/CrashGames/ViewGame.vue");

const AllGames = () => import("../components/CrashGames/AllGames.vue");

const LigiBigi = () => import("../components/LigiBigi/GamePage.vue");

const ReferAndChop = () => import("../components/ReferAndChop/Index.vue");

const Leaderboard = () => import("../components/Leaderboard/Leaderboard.vue");
const SiteMap = () => import("../components/SeoContentBlock/SiteMap.vue");

// Get Layout Components
const Mobile = () => import("../layouts/Mobile.vue");
const Desktop = () => import("../layouts/Desktop.vue");

const CountrySelector = () =>
	import("../components/Shared/CountrySelector.vue");

import { cookie } from "../utils";
import { env } from "../utils/env";

function getUserIdFromLocalStorage() {
	try {
		const userData = localStorage.getItem("user"); // Assuming the key is 'user_data'
		if (userData) {
			const user = JSON.parse(userData);
			return user.id;
		} else {
			console.warn("No user data found in local storage");
			return null;
		}
	} catch (e) {
		console.error("Failed to parse user data from local storage", e);
		return null;
	}
}

const userAuth = JSON.parse(localStorage.getItem("authenticated")) === true;
const profileID = getUserIdFromLocalStorage();

function getConfigurableRoutes() {
	const routes = [
		{
			path: "/sitemap.xml",
			name: "sitemap-xml",
			component: SiteMap,
			meta: {
				sitemap: true,
			},
		},
		{
			path: "/sitemap",
			name: "sitemap",
			component: SiteMap,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: true,
				showBetslip: true,
				requireAuth: false,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/betslip",
			name: "betslip",
			component: MainBetslip,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/",
			name: "home",
			component: Home,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: true,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/sport-leagues",
			name: "sport-leagues",
			component: TopLeagues,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: true,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/search",
			name: "search",
			component: Search,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: true,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/s/:sportName",
			name: "sport",
			component: Home,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: true,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
			children: [
				{
					path: "/s/:sportName/countries",
					name: "sport-countries",
					component: Countries,
					meta: {
						miniBetslipViewable: false,
						showLiveNav: false,
						showPrematchNav: true,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
			],
		},
		{
			path: "/s/:sportName/:competitionName",
			name: "sport-competition",
			component: Home,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: true,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/m/:parentMatchId",
			name: "prebet-markets",
			component: PrebetMarkets,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: true,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			name: "login",
			path: "/login",
			component: Login,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: false,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			name: "register",
			path: "/register",
			component: env.kyc.required ? KycAllRequirements : Register,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: false,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			name: "kyc",
			path: "/kyc",
			component: KycInitial,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: false,
				showHeader: true,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},

		{
			name: "profile",
			path: "/profile",
			component: Profile,

			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: false,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},

		{
			name: "profile-deposit",
			path: "/profile/deposit",
			component: DepositPage,

			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: false,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},

		{
			name: "profile-withdraw",
			path: "/profile/withdraw",
			component: WithdrawPage,

			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: false,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/profile/transactions",
			component: Transactions,
			name: "profile-transactions",
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/mybets",
			name: "mybets",
			component: MyBets,

			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			name: "mybets-betdetail",
			path: "/mybets/:betId",
			component: MyBetsBetDetail,

			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			name: "mybets-betdetail-short",
			path: "/b/:shortBetId",
			component: MyBetsBetDetail,

			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/live",
			name: "live",
			component: Live,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: true,
				showPrematchNav: false,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/live/:sportName",
			name: "live-sport",
			component: Live,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: true,
				showPrematchNav: false,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/live/m/:matchId",
			name: "live-markets",
			component: LiveMarkets,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: true,
				showPrematchNav: false,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/forgotpassword",
			component: ResetPassword,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/share/:shareCode",
			name: "share-receiver",
			component: Share,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/share",
			name: "share-receiver",
			component: Share,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/notifications",
			name: "notifications",
			component: Notifications,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/notifications/details",
			name: "notifications-details",
			component: NotificationsDetails,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/legal",
			name: "termsAndConditions",
			component: TermsAndConditions,
			props: true,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/legal/:categoryName",
			name: "termsAndConditionsCategory",
			component: TermsAndConditionsSubCategories,
			props: true,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/legal/:categoryName/:subCategoryName",
			name: "termsAndConditionsContent",
			component: TermsAndConditionsMiniCategoriesOrContent,
			props: true,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/legal/:categoryName/:subCategoryName/:miniCategoryName",
			name: "termsAndConditionsMiniCategory",
			component: TermsAndConditionsMiniCategory,
			props: true,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/freebets",
			name: "free-bets",
			component: FreeBets,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/freebets/:id",
			name: "free-bets-detail",
			component: FreeBetsDetails,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/profile/transaction-history",
			name: "transaction-history",
			component: TransactionHistory,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/profile/transaction-history/:id",
			name: "transaction-history-single",
			component: TransactionHistorySingle,
			props: true,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: true,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/promotion/:promoName/:promoId",
			name: "promotion-single",
			component: PromotionSingle,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/promotion/static/:promoName/:promoId",
			name: "promotion-single-static",
			component: PromotionSingleStatic,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/promotions",
			name: "promotions",
			component: PromosList,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/ligi-bigi",
			name: "ligi-bigi",
			component: LigiBigi,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				centerOnlyLayout: true,
				showLeftNav: false,
				showRightNav: false,
			},
		},
	];

	/**
	 *  Configurable routes
	 *  */
	const livescoreRoutes = [
		{
			path: "/livescore",
			name: "livescore",
			component: LiveScore,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: true,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
	];

	if (
		Object.keys(env).length > 0 &&
		env.availableProducts.includes("livescore")
	)
		routes.push(...livescoreRoutes);

	const downloadFixturesRoutes = [
		{
			name: "download-fixtures",
			path: "/download-fixtures",
			component: DownloadFixtures,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
	];

	if (
		Object.keys(env).length > 0 &&
		env.availableProducts.includes("downloadFixtures")
	)
		routes.push(...downloadFixturesRoutes);

	const goldenRaceRoutes = [
		{
			path: "/betika-super-league",
			name: "betika-super-league",
			component: GoldenRaceGames,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				showLeftNav: false,
				showRightNav: false,
			},
		},
	];

	if (
		Object.keys(env).length > 0 &&
		env.availableProducts.includes("goldenRace")
	)
		routes.push(...goldenRaceRoutes);

	const casinoRoutes = [
		{
			path: "/casino",
			name: "casino",
			component: Casino,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				centerOnlyLayout: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/casino/category/:categoryName",
			name: "casino-category",
			component: CasinoCategoryDetail,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				centerOnlyLayout: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/casino/game",
			name: "casino-game",
			component: CasinoGamePage,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				centerOnlyLayout: true,
				showLeftNav: false,
				showRightNav: false,
			},
		},
	];
	if (env.availableProducts.includes("casino")) routes.push(...casinoRoutes);
	const splitPotNameBaseRoute =
		env.availableProducts.includes("splitPot") &&
		env.splitPotName.replace(/\s/gi, "-").toLowerCase();

	const crashGamesRoutes = [
		{
			path: "/crash-games",
			name: "crash-games",
			component: crashGames,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				centerOnlyLayout: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/crash-game/:gameID/",
			name: "crash-game",
			component: crashGamesGamePage,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				centerOnlyLayout: true,
				showLeftNav: false,
				showRightNav: false,
			},
		},
		{
			path: "/crash-games/all",
			name: "view-all-games",
			component: AllGames,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				centerOnlyLayout: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
	];
	if (env.availableProducts.includes("crashGames"))
		routes.push(...crashGamesRoutes);

	const splitPotRoutes = [
		{
			path: `/${splitPotNameBaseRoute}`,
			name: `${splitPotNameBaseRoute}`,
			component: splitPot,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				centerOnlyLayout: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: `/${splitPotNameBaseRoute}/:gameKind/:gameVariant`,
			name: `${splitPotNameBaseRoute}-game`,
			component: splitPotGamePage,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				centerOnlyLayout: true,
				showLeftNav: false,
				showRightNav: false,
			},
		},
		{
			path: `/comet-crash`,
			name: `comet-crash`,
			component: cometCrash,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				centerOnlyLayout: true,
				showLeftNav: false,
				showRightNav: false,
			},
		},
	];
	if (env.availableProducts.includes("splitPot"))
		routes.push(...splitPotRoutes);

	const spribeRoutes = [
		{
			path: `/spribe`,
			name: `spribe`,
			component: Spribe,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				centerOnlyLayout: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: `/aviator`,
			name: `spribe-game`,
			component: SpribeGamePage,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				centerOnlyLayout: true,
				showLeftNav: false,
				showRightNav: false,
			},
		},
	];
	if (env.availableProducts.includes("aviator")) routes.push(...spribeRoutes);

	const virtualHubRoutes = [
		{
			path: "/virtuals",
			name: "virtuals",
			component: VirtualsHub,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				centerOnlyLayout: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/virtual/:game_id",
			name: "virtual-game",
			component: VirtualsGamePage,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				centerOnlyLayout: true,
				showLeftNav: false,
				showRightNav: false,
			},
		},
		{
			path: "/virtuals",
			name: "virtuals",
			component: Virtuals,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
			children: [
				{
					path: "matches/:id",
					name: "virtuals-matches",
					components: {
						default: Matchdays,
					},
					meta: {
						miniBetslipViewable: true,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: "table/:id",
					name: "virtuals-table",
					components: {
						default: Table,
						main: Matchdays,
					},
					meta: {
						miniBetslipViewable: true,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: "results/:id",
					name: "virtuals-results",
					components: {
						default: Results,
						main: Matchdays,
					},
					meta: {
						miniBetslipViewable: true,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: "ongoing/:id",
					name: "virtuals-ongoing",
					components: {
						default: Ongoing,
						main: Matchdays,
					},
					meta: {
						miniBetslipViewable: true,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: "markets/:id",
					name: "virtuals-markets",
					components: {
						default: null,
						main: VirtualMarkets,
					},
					meta: {
						miniBetslipViewable: true,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: false,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
			],
		},
	];
	if (
		Object.keys(env).length > 0 &&
		env.availableProducts.includes("virtualHub")
	)
		routes.push(...virtualHubRoutes);

	const virtualsRoutes = [
		{
			path: "/virtual",
			name: "virtual",
			component: Leagues,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: "/virtuals",
			name: "virtuals",
			component: Virtuals,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
			children: [
				{
					path: "matches/:id",
					name: "virtuals-matches",
					components: {
						default: Matchdays,
					},
					meta: {
						miniBetslipViewable: true,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: "table/:id",
					name: "virtuals-table",
					components: {
						default: Table,
						main: Matchdays,
					},
					meta: {
						miniBetslipViewable: true,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: "results/:id",
					name: "virtuals-results",
					components: {
						default: Results,
						main: Matchdays,
					},
					meta: {
						miniBetslipViewable: true,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: "ongoing/:id",
					name: "virtuals-ongoing",
					components: {
						default: Ongoing,
						main: Matchdays,
					},
					meta: {
						miniBetslipViewable: true,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: "markets/:id",
					name: "virtuals-markets",
					components: {
						default: null,
						main: VirtualMarkets,
					},
					meta: {
						miniBetslipViewable: true,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: true,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: false,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
			],
		},
	];
	if (Object.keys(env).length > 0 && env.availableProducts.includes("virtuals"))
		routes.push(...virtualsRoutes);

	let jisortBaseRoute = "";
	if (Object.keys(env).length > 0) {
		jisortBaseRoute = env.jisort.productName.replace(/\s/gi, "-").toLowerCase();
	}
	const jisortRoute = {
		path: `/profile/${jisortBaseRoute}`,
		name: "jisort",
		component: Jisort,
		meta: {
			miniBetslipViewable: false,
			showLiveNav: false,
			showPrematchNav: false,
			showBetslip: false,
			requireAuth: true,
			requireKYC: env.kyc.required,
			showHeader: true,
			showTopNav: false,
			showFooter: false,
			showLeftNav: true,
			showRightNav: true,
		},
	};
	routes.push(jisortRoute);

	const accountDeleteRoute = {
		path: `/profile/delete`,
		name: "delete-account",
		component: DeleteAccount,
		meta: {
			miniBetslipViewable: false,
			showLiveNav: false,
			showPrematchNav: false,
			showBetslip: false,
			requireAuth: true,
			requireKYC: env.kyc.required,
			showHeader: true,
			showTopNav: false,
			showFooter: false,
			showLeftNav: true,
			showRightNav: true,
		},
	};
	if (!env.disabledFeatures.includes("accountDelete"))
		routes.push(accountDeleteRoute);

	let shikishaBaseRoute = "";
	if (Object.keys(env).length > 0) {
		shikishaBaseRoute = env.shikishaProductName
			.replace(/\s/gi, "-")
			.toLowerCase();
	}
	const shikishaRoutes = [
		{
			path: `/${shikishaBaseRoute}`,
			name: `${shikishaBaseRoute}`,
			component: Shikisha,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
		{
			path: `/${shikishaBaseRoute}/markets/:parentMatchId`,
			name: `${shikishaBaseRoute}-markets`,
			component: ShikishaMarkets,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
	];

	if (Object.keys(env).length > 0 && env.availableProducts.includes("shikisha"))
		routes.push(...shikishaRoutes);

	const jackpotRoutes = [
		{
			name: "jackpots",
			path: "/jackpots",
			component: WeeklyJackpot,
			alias: "/jackpot",
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
			children: [
				{
					path: "",
					name: "grand-jackpot",
					component: GrandJackpotEvent,
					meta: {
						miniBetslipViewable: false,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: false,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},

				{
					path: "midweekjp",
					name: "midweek-jackpot",
					component: MidweekJackpot,
					meta: {
						miniBetslipViewable: false,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: false,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: "results",
					name: "jackpot-results",
					component: WeeklyJackpotResults,
					alias: "/jackpot/results",
					meta: {
						miniBetslipViewable: false,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: false,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: "result",
					name: "jackpot-result",
					component: JackpotResult,
					alias: "/jackpot/result",
					meta: {
						miniBetslipViewable: false,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: false,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
			],
		},
	];

	if (env.availableProducts.includes("jackpots")) routes.push(...jackpotRoutes);

	const lottoRoute = [
		{
			path: "/betika-lotto",
			name: "betikaLotto",
			component: betikaLotto,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: true,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		}
	];

	if (env.availableProducts.includes("betikaLotto")) routes.push(...lottoRoute);

	const sababishaBaseRoute = env.sababishaProductName
		.replace(/\s/gi, "-")
		.toLowerCase();
	const dailyJpRoutes = [
		{
			path: `/jackpots/${sababishaBaseRoute}`,
			name: "boosted-multibet",
			alias: `/${sababishaBaseRoute}`,
			component: BoostedMultibet,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
			children: [
				{
					path: "",
					name: "boosted-multibet-events",
					component: BoostedMultibetEvents,
					meta: {
						miniBetslipViewable: false,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: false,
						requireAuth: false,
						requireKYC: env.kyc.required,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
				{
					path: `/jackpots/${sababishaBaseRoute}/:id`,
					name: "boosted-multibet-event",
					component: BoostedMultibetEvent,
					meta: {
						miniBetslipViewable: false,
						showLiveNav: false,
						showPrematchNav: false,
						showBetslip: false,
						requireAuth: false,
						requireKYC: true,
						showHeader: true,
						showTopNav: true,
						showFooter: true,
						showLeftNav: true,
						showRightNav: true,
					},
				},
			],
		},
	];

	if (env.availableProducts.includes("dailyJp"))
		jackpotRoutes[0].children.push(...dailyJpRoutes);

	const snapikaRoutes = [
		{
			path: "/snap",
			name: "live-snap",
			component: BetikaSnap,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: true,
				showPrematchNav: false,
				showBetslip: true,
				requireAuth: false,
				requireKYC: false,
				showHeader: true,
				showTopNav: false,
				showFooter: false,
				showLeftNav: true,
				showRightNav: true,
			},
		},
	];
	if (!env.disabledFeatures.includes("snapika")) routes.push(...snapikaRoutes);

	const referAndChop = [
		{
			path: "/" + env.betikaAffiliates.routePath,
			name: "refer-and-chop",
			component: ReferAndChop,
			meta: {
				miniBetslipViewable: false,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: false,
				showTopNav: false,
				showFooter: false,
				centerOnlyLayout: true,
				showLeftNav: false,
				showRightNav: false,
			},
		},
	];
	if (!env.disabledFeatures.includes("referAndChop"))
		routes.push(...referAndChop);

	// let leaderboardBaseRoute = "";
	// if (Object.keys(env).length > 0) {
	// 	leaderboardBaseRoute = env.leaderBoardName
	// 		.replace(/\s/gi, "-")
	// 		.toLowerCase();
	// }
	const leaderboardBaseRoutes = [
		{
			path: `/leaderboard`,
			name: `Leaderboard`,
			component: Leaderboard,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: false,
				showBetslip: true,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
	];

	if (
		Object.keys(env).length > 0 &&
		env.availableProducts.includes("leaderboard")
	)
		routes.push(...leaderboardBaseRoutes);

	const catchAllRoute = [
		{
			path: "*",
			component: Home,
			meta: {
				miniBetslipViewable: true,
				showLiveNav: false,
				showPrematchNav: true,
				showBetslip: false,
				requireAuth: false,
				requireKYC: env.kyc.required,
				showHeader: true,
				showTopNav: true,
				showFooter: true,
				showLeftNav: true,
				showRightNav: true,
			},
		},
	];
	routes.push(...catchAllRoute);
	return routes;
}

function setupRoutes() {
	return new Promise((resolve, reject) => {
		const notifications = require("../utils/notifications").default;
		let configsLoaded = store.getters.countryConfigsLoaded;
		let configurableRoutes = configsLoaded ? getConfigurableRoutes() : [];
		// TODO: Change redirect based on whether ENV is loaded
		//TODO: Add redirect to country selector route if env not loaded
		// const localeRoutes = [
		// 	{
		// 		path: "/",
		// 		redirect: env.locale,
		// 	},
		// 	{
		// 		path: "/:locale",
		// 		component: Root,
		// 		name: "rootLocaleRoute",
		// 		beforeEnter: (to, from, next) => {
		// 			const locale = to.params.locale;
		// 			const supported_locales = ["en-ke", "sw-ke", "en-gh", "en-ng"];

		// 			if (!supported_locales.includes(locale)) return next("en-ke");
		// 			if (i18n.locale !== locale) {
		// 				i18n.locale = locale;
		// 			}
		// 			return next();
		// 		},
		// 		children: configurableRoutes,
		// 	},
		// ];
		const localeRoutes = configurableRoutes;
		const noConfigsLoadedRoutes = [
			{
				path: "/",
				component: CountrySelector,
				name: "countrySelector",
			},
		];

		const router = new VueRouter({
			routes: store.getters.countryConfigsLoaded
				? localeRoutes
				: noConfigsLoadedRoutes,
			scrollBehavior(to, from, savedPosition) {
				if (savedPosition) {
					return savedPosition;
				} else {
					if (to.name === "betslip") {
						return savedPosition;
					}
					return { x: 0, y: 0 };
				}
			},
			base: i18n.locale,
			mode: "history",
		});

		// Cleanup any existing router hooks to prevent memory leaks
		// Only needed if the router is re-initialized multiple times
		if (router.beforeHooks && router.beforeHooks.length) {
			console.warn('Cleaning up existing router hooks to prevent memory leaks');
			router.beforeHooks = [];
		}

		// Also clean up after hooks and resolve hooks if they exist
		if (router.afterHooks && router.afterHooks.length) {
			router.afterHooks = [];
		}

		if (router.resolveHooks && router.resolveHooks.length) {
			router.resolveHooks = [];
		}

		// Main navigation guard for SEO redirects
		router.beforeEach((to, from, next) => {
			const cookieValue = cookie.get('setDefaultCurrentSiteToRevamp');

			if (cookieValue === 'true' && env.setDefaultSiteToRevamp) {
				// Redirect to external site
				window.location.href = env.newHomePage.link;
				return;
			}

			try {
				// Check if user is coming from an external link or search engine
				const isExternalReferrer = document.referrer &&
					document.referrer !== '' &&
					!document.referrer.includes(window.location.host);

				// Check if user is navigating internally (already on the site)
				const isInternalNavigation = from.name !== null;

				// More comprehensive search engine detection
				const searchEnginePatterns = [
					/google\./i, /bing\./i, /yahoo\./i, /yandex\./i, /baidu\./i,
					/duckduckgo\./i, /ecosia\./i, /qwant\./i, /ask\./i, /aol\./i,
					/naver\./i, /search\./i, /searchengine\./i, /msn\./i, /sogou\./i
				];

				const isSearchEngine = isExternalReferrer &&
					searchEnginePatterns.some(pattern => pattern.test(document.referrer));

				// Also check for search-related query parameters
				const hasSearchParams = window.location.search &&
					(window.location.search.includes('q=') ||
					window.location.search.includes('query=') ||
					window.location.search.includes('search='));

				// Special parameter for local testing of SEO redirects
				const isLocalSEOTest = window.location.search.includes('seo_test=true');

				// Check for Googlebot or other search engine user agents
				const userAgent = navigator.userAgent || '';
				const isSearchEngineUserAgent = /googlebot|bingbot|yandexbot|slurp|duckduckbot|baiduspider|sogou|exabot|facebot|ia_archiver/i.test(userAgent);

				// Check if the path is a login or registration page
				const isLoginPage = to.path === '/login' || to.path.endsWith('/login');
				const isRegisterPage = to.path === '/register' || to.path.endsWith('/register');
				const isAuthPage = isLoginPage || isRegisterPage;

				// CRITICAL: If this is an internal navigation (user already on site),
				// allow them to navigate freely to login/register pages
				if (isInternalNavigation && isAuthPage) {
					// User is navigating from within the site to login/register - allow it
					next();
					return;
				}

				// Is user coming from a search engine (both crawler or real user)?
				const isFromSearchEngine = isSearchEngine || hasSearchParams || isSearchEngineUserAgent || isLocalSEOTest;

				// If user is coming directly from a search engine to auth page, use proper redirect method
				if (isFromSearchEngine && isAuthPage) {
					console.log('Redirecting from auth page to homepage');

					// Check if we're handling a search engine crawler
					if (isSearchEngineUserAgent || isLocalSEOTest) {
						// For crawlers, we can use Vue Router's next() for redirection
						next('/');
					} else {
						// For real users, use a delayed window.location.href approach
						// to ensure stylesheets are loaded first

						// First, let the page load fully including stylesheets
						next();

						// Then perform the redirect after a short delay
						setTimeout(() => {
							window.location.href = '/';
						}, 50); // Small delay to ensure CSS loads

						return;
					}
					return;
				}

				// Handle SEO configuration if available
				if (env.seoConfiguration) {
					try {
						// Handle redirect according to SEO configuration
						if (isFromSearchEngine && isAuthPage &&
								env.seoConfiguration.redirectRules &&
								env.seoConfiguration.redirectRules.fromSearchEngines === "home") {

							if (isSearchEngineUserAgent) {
								// For crawlers, use Vue Router redirect
								next('/');
							} else {
								// For real users, use delayed window.location to ensure styles load
								next();
								setTimeout(() => {
									window.location.href = '/';
								}, 50);
								return;
							}
							return;
						}

						// Handle excluded paths
						if (isFromSearchEngine &&
								env.seoConfiguration.excludeFromIndex &&
								Array.isArray(env.seoConfiguration.excludeFromIndex) &&
								env.seoConfiguration.excludeFromIndex.includes(to.path)) {

							// Use default landing page from config if available, otherwise fallback to home
							const defaultPage = env.seoConfiguration.defaultLandingPage || '/';

							if (isSearchEngineUserAgent) {
								// For crawlers, use Vue Router redirect
								next(defaultPage);
							} else {
								// For real users, use delayed window.location to ensure styles load
								next();
								setTimeout(() => {
									window.location.href = defaultPage;
								}, 50);
								return;
							}
							return;
						}
					} catch (error) {
						console.error('Error in SEO router handling:', error);
						// Proceed with navigation on error
					}
				} else {
					// Generic handling for countries without specific SEO configuration
					if (isFromSearchEngine && isAuthPage) {
						if (isSearchEngineUserAgent) {
							// For crawlers, use Vue Router redirect
							next('/');
						} else {
							// For real users, use delayed window.location to ensure styles load
							next();
							setTimeout(() => {
								window.location.href = '/';
							}, 50);
							return;
						}
						return;
					}
				}
			} catch (error) {
				console.error('Error in router beforeEach:', error);
				// Continue with navigation if there's an error
			}

			next(); // proceed with navigation
		});

		// Auth guard - only register if country configs are loaded
		if (store.getters.countryConfigsLoaded) {
			router.beforeEach((to, from, next) => {
				if (to.meta.requireAuth && !auth.getAuthStatus()) {
					return router.push({ name: "login", query: { next: to.fullPath } });
				}

				const token = to.query.token;
				if (token !== undefined) {
					// Save token as a cookie
					// let token = this.$utils.getParameterByName("token");
					if (token.isMatch("^[A-Za-z0-9_-]{32}$")) {
						cookie.set("aff_token", token, 30);
					}
				}

				// Save utm_medium and utm_source when on home page
				if (to.path === "/") {
					const utmMedium = to.query.utm_medium;
					const utmSource = to.query.utm_source;
					const utmCampaign = to.query.utm_campaign;

					let utm = {
						medium: utmMedium,
						source: utmSource,
						campaign: utmCampaign,
					};

					if (
						store.getters.utmInfo == null ||
						Object.entries(utm).length == 0
					) {
						store.commit("setUtmInfo", utm);
					}
				}

				analyticsPlugin.general.pageView({
					pageUrl: to.fullPath,
					isAuthenticated: userAuth ? "Authenticated" : "Not Authenticated",
					user_id: profileID,
				});
				next();
			});
		}

		// Add a global router error handler
		router.onError((error) => {
			console.error('Router error:', error);
		});

		resolve(router);
	});
}

export { getConfigurableRoutes, setupRoutes };
